(ns common.schema.entities.job
  (:require [common.schema.schema-utils :as su]))

(def schema
  [[:job/client-identifier {:field/data-type             :data.type/text-simple
                            :field/default-ord           10
                            :field/lower-case-str?       true
                            :field/default-visibility    {:editor           :editor.type/none
                                                          :grid             :editor.type/none
                                                          :filter           :filter.type/none
                                                          :field-visibility :in-use-disabled}
                            :field/default-authorization {:access/read  :role/user
                                                          :access/write :role/user}
                            :field/not-clearable?        true
                            :field/translations          {:en "Client side identifier"}}]
   [:job/result {:field/data-type             :data.type/text
                 :field/default-ord           20
                 :field/default-visibility    {:editor           :editor.type/none
                                               :grid             :editor.type/none
                                               :filter           :filter.type/none
                                               :field-visibility :in-use-disabled}
                 :field/default-authorization {:access/read  :role/user
                                               :access/write :role/user}
                 :field/not-clearable?        true
                 :field/translations          {:en "Result data"}}]
   [:job/status {:field/data-type             :data.type/keyword
                 :field/default-ord           20
                 :value-type                  :keyword
                 :field/default-visibility    {:editor           :editor.type/text-simple
                                               :grid             :editor.type/text-simple
                                               :filter           :filter.type/text
                                               :field-visibility :in-use-disabled}
                 :field/default-authorization {:access/read  :role/user
                                               :access/write :role/system}
                 :field/system-semantics      su/system-controlled-optional-field-semantics
                 :options                     [{:key   :job.status/finished
                                                :label "Finished"}
                                               {:key   :job.status/error
                                                :label "Error"}
                                               {:key   :job.status/not-started
                                                :label "Not started"}]
                 :field/translations          {:en "Status"}}]
   [:job/owner {:field/data-type             :data.type/ref-single
                :field/default-ord           30
                :field/not-clearable?        true
                :value-type                  :entity
                :field/entity-types          [:entity.type/account]
                :field/constraints           {}
                :field/default-visibility    {:editor           :editor.type/select
                                              :grid             :editor.type/select
                                              :filter           :filter.type/select
                                              :field-visibility :in-use-disabled}
                :field/default-authorization {:access/read  :role/user
                                              :access/write :role/system}
                :field/system-semantics      su/system-controlled-not-clearable-field-semantics
                :field/translations          {:en "Job owner"}}]
   [:job/zadmin-owner {:field/data-type             :data.type/ref-single
                       :field/not-clearable?        true
                       :value-type                  :entity
                       :field/entity-types          [:entity.type/account]
                       :field/constraints           {}
                       :field/default-visibility    {:editor           :editor.type/none
                                                     :grid             :editor.type/none
                                                     :filter           :filter.type/none
                                                     :field-visibility :in-use-disabled}
                       :field/default-authorization {:access/read  :role/zadmin
                                                     :access/write :role/system}
                       :field/system-semantics      su/system-controlled-not-clearable-field-semantics
                       :field/translations          {:en "Zadmin owner"}}]])
